// extracted by mini-css-extract-plugin
export default {"modal":"Tour_modal__JtPZ+","tourIndex":"Tour_tourIndex__-d8qz","text":"Tour_text__R8zmx","close":"Tour_close__rp0xi"};